export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--P.5dedf2ac.png";